import React, { ComponentProps, FC } from 'react';

import classNames from 'classnames';
import { prop } from 'ramda';

import BaseToggler from 'components/shared/FormAdapters/FormBase/Toggler';

import styles from './index.module.css';
import { ITogglerProps } from './types';

const COLOR_THEME = {
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY',
};

const COLORS: Record<string, any> = {
  PRIMARY: {
    CHECKED: 'var(--success_color)',
    UNCHECKED: 'var(--danger_color)',
  },
  SECONDARY: {
    CHECKED: 'var(--primary_color)',
    UNCHECKED: '#dadada',
  },
};

const Toggler: FC<ITogglerProps & ComponentProps<typeof BaseToggler>> = ({
  className,
  checkboxClassName,
  noMargin,
  size,
  children,
  isError,
  theme = COLOR_THEME.PRIMARY,
  ...rest
}) => {
  const { disabled, checked } = rest;
  const checkboxWrapperClasses = classNames(
    styles.togglerWrapper,
    noMargin && prop('togglerWrapper-noMargin', styles),
    checked && prop('togglerWrapper-active', styles),
    isError && prop('togglerWrapper-error', styles),
    disabled && prop('togglerWrapper-disabled', styles),
    size && prop(`togglerWrapper-${size}`, styles),
    !children && prop('togglerWrapper-noTitle', styles),
    className,
  );

  const checkboxClasses = classNames(
    styles.toggler,
    checkboxClassName,
    checked && prop('toggler-active', styles),
    disabled && prop('toggler-disabled', styles),
  );

  return (
    <label className={checkboxWrapperClasses}>
      <BaseToggler {...rest} className={styles.hiddenBaseTogglerButton} />
      <span
        className={checkboxClasses}
        style={{ backgroundColor: checked ? COLORS[theme].CHECKED : COLORS[theme].UNCHECKED }}
      />
      {children && <span className={styles.togglerTitle}>{children}</span>}
    </label>
  );
};

//@ts-ignore
Toggler.THEME = COLOR_THEME;
export default Toggler;
